import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import '../static/css/font.css';
import axios from "axios";
import decimal from './util/decimal'
Vue.prototype.$decimal = decimal;
Vue.prototype.$axios = axios;
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.use(Vant);
import { DatetimePicker } from 'vant';

Vue.use(DatetimePicker);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})


// WEBPACK FOOTER //
// ./src/main.js